var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
/**
 * SVG icons for each authority record type.
 * All icons are 26x26, white stroke on transparent background,
 * designed to sit inside a colored gradient circle.
 */
import React from 'react';
import { RecordType } from '../../types/api';
var iconProps = {
    width: 26,
    height: 26,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'white',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
};
export var AUTHORITY_TYPE_ICONS = (_a = {},
    _a[RecordType.PERSONAL] = (React.createElement("svg", __assign({}, iconProps),
        React.createElement("circle", { cx: "12", cy: "7", r: "4" }),
        React.createElement("path", { d: "M5.5 21a6.5 6.5 0 0 1 13 0" }))),
    _a[RecordType.CORPORATE] = (React.createElement("svg", __assign({}, iconProps),
        React.createElement("rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }),
        React.createElement("path", { d: "M9 21V12h6v9" }),
        React.createElement("path", { d: "M3 9h18" }))),
    _a[RecordType.MEETING] = (React.createElement("svg", __assign({}, iconProps),
        React.createElement("rect", { x: "3", y: "4", width: "18", height: "18", rx: "2" }),
        React.createElement("path", { d: "M16 2v4M8 2v4M3 10h18" }))),
    _a[RecordType.UNIFORM_TITLE] = (React.createElement("svg", __assign({}, iconProps),
        React.createElement("path", { d: "M4 19.5A2.5 2.5 0 0 1 6.5 17H20" }),
        React.createElement("path", { d: "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" }))),
    _a[RecordType.SUBJECT] = (React.createElement("svg", __assign({}, iconProps),
        React.createElement("path", { d: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" }),
        React.createElement("circle", { cx: "7", cy: "7", r: "1.5", fill: "white" }))),
    _a[RecordType.CHRONOLOGICAL] = (React.createElement("svg", __assign({}, iconProps),
        React.createElement("circle", { cx: "12", cy: "12", r: "10" }),
        React.createElement("path", { d: "M12 6v6l4 2" }))),
    _a[RecordType.GEOGRAPHIC] = (React.createElement("svg", __assign({}, iconProps),
        React.createElement("path", { d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" }),
        React.createElement("circle", { cx: "12", cy: "9", r: "2.5" }))),
    // CZNA-181: old-print city (Aleph prefix pv, MARC 195). Adapts the
    // GEOGRAPHIC map-pin and adds an open-book mark to evoke the early-printed
    // book imprint context.
    _a[RecordType.OLD_PRINT_CITY] = (React.createElement("svg", __assign({}, iconProps),
        React.createElement("path", { d: "M12 2C8.69 2 6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11c0-3.31-2.69-6-6-6z" }),
        React.createElement("path", { d: "M9.5 7.2c.8-.5 1.7-.5 2.5 0 .8-.5 1.7-.5 2.5 0v3.4c-.8-.5-1.7-.5-2.5 0-.8-.5-1.7-.5-2.5 0V7.2z" }),
        React.createElement("path", { d: "M12 7.2v3.4" }))),
    _a[RecordType.GENRE_FORM] = (React.createElement("svg", __assign({}, iconProps),
        React.createElement("path", { d: "M4 19.5A2.5 2.5 0 0 1 6.5 17H20" }),
        React.createElement("path", { d: "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" }),
        React.createElement("path", { d: "M8 7h8M8 11h6" }))),
    // TASK-140: conspect group (MARC 190) — stacked layers, the classification
    // grouping that sits above individual subject headings.
    _a[RecordType.CONSPECT_GROUP] = (React.createElement("svg", __assign({}, iconProps),
        React.createElement("path", { d: "M12 2L2 7l10 5 10-5-10-5z" }),
        React.createElement("path", { d: "M2 17l10 5 10-5M2 12l10 5 10-5" }))),
    // CZNA-422: name-title authority — the UNIFORM_TITLE book with the person
    // mark of the author whose 1XX carries it.
    _a[RecordType.AUTHOR_WORK] = (React.createElement("svg", __assign({}, iconProps),
        React.createElement("path", { d: "M4 19.5A2.5 2.5 0 0 1 6.5 17H20" }),
        React.createElement("path", { d: "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" }),
        React.createElement("circle", { cx: "13", cy: "8", r: "2" }),
        React.createElement("path", { d: "M10 14a3 3 0 0 1 6 0" }))),
    _a);
